export default __webpack_public_path__ + "static/media/IS IT audit.0e62a013.png";